import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { map, Observable } from 'rxjs';
import { ChatMessage } from '../interfaces/chat-message.interface';

@Injectable({
  providedIn: 'root',
})
export class AiChatServiceService {
  constructor(private http: HttpClient) {}

  public createChatSession(): Observable<string> {
    return this.http.post<string>(`${environment.api}/services/customer/v2/b/chat/sessions`, {});
  }

  public sendMessage(token: string | null, message: string): Observable<ChatMessage> {
    return this.http.post<ChatMessage>(`${environment.api}/services/customer/v2/b/chat/sessions/${token}/message`, { message }).pipe(
      map((response) => ({
        ...response,
        timestamp: new Date(),
        type: 'ai' as 'user' | 'ai',
      }))
    );
  }

  public closeChatSession(token: string | null): Observable<void> {
    return this.http.delete<void>(`${environment.api}/services/customer/v2/b/chat/sessions/${token}`);
  }
}
